import { render, staticRenderFns } from "./OfertaList.vue?vue&type=template&id=73d610f4&scoped=true&"
import script from "./OfertaList.vue?vue&type=script&lang=js&"
export * from "./OfertaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d610f4",
  null
  
)

export default component.exports